import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import style from './index.css';
import PropTypes from 'prop-types';
const Time = ({ timeInfo }) => {
    const judgestyle = () => {
        return {
            time: {
                backgroundImage: `url(${timeInfo.backgroundPic})`,
            },
            nowtime: {
                backgroundImage: `url(${timeInfo.titlePic})`,
            },
            nextupdatetime: {
                background: timeInfo.todayHighlightColor,
            },
        };
    };

    return (
        <div className={style.time} style={judgestyle().time}>
            <div className={style.nowtime} style={judgestyle().nowtime}>
                <div className={style.nowdatetime}>{timeInfo.dateStr}</div>
            </div>
            <div className={style.nextupdatetime} style={judgestyle().nextupdatetime}>
                <div>下次更新时间</div>
                <div className={style.nexthour}>{timeInfo.nextUpdateTime}</div>
            </div>
        </div>
    );
};

Time.propTypes = {
    timeInfo: PropTypes.object,
};

export default errorBoundary(Time);
